// Package Imports
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

// Core Imports
import { queryClient } from '@/core/lib/query-client'
import { requireAuth } from '@/core/lib/route-guards'
import { rootRoute } from '@/core/routes'
import PageSkeleton from '@/core/components/page-skeleton'
import RouteError from '@/core/components/route-error'

// Module Imports
import DashboardLayout from '@/modules/dashboard/pages/dashboard-layout.page'
import { dashboardStatsQueryOptions } from '@/modules/dashboard/dashboard.hooks'

export const dashboardRoute = createRoute({
  path: '/dashboard',
  getParentRoute: () => rootRoute,
  beforeLoad: requireAuth,
  component: DashboardLayout,
  errorComponent: ({ error, reset }) => (
    <RouteError error={error} reset={reset} />
  ),
})

export const homeRoute = createRoute({
  getParentRoute: () => dashboardRoute,
  path: '/',
  loader: async () => {
    await queryClient.ensureQueryData(dashboardStatsQueryOptions())
  },
  pendingComponent: () => <PageSkeleton />,
  pendingMs: 100,
  component: lazyRouteComponent(
    () => import('@/modules/dashboard/pages/home.page')
  ),
})

export const forbiddenRoute = createRoute({
  getParentRoute: () => dashboardRoute,
  path: '/forbidden',
  head: () => ({
    meta: [{ title: 'Yetkisiz Erişim' }],
  }),
  component: lazyRouteComponent(
    () => import('@/modules/dashboard/pages/forbidden.page')
  ),
})
